import type { ReactNode } from 'react'

/**
 * Roadmap tab (spec §10): intentionally blank pending design — a single
 * muted empty-state card, permanently, not a placeholder lanes replace.
 */
export function RoadmapTab(): ReactNode {
  return (
    <div className="rounded-xl border border-dashed border-(--cd-border-2) bg-(--cd-card) p-8 text-center">
      <p className="text-sm font-medium text-(--cd-text-muted)">
        Roadmap — coming soon
      </p>
    </div>
  )
}
